import { useTranslation } from 'react-i18next';
import { trackTrendyolConversion } from '../../../hooks/useConversionTracking';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <div className="bg-gradient-to-r from-orange-50 to-amber-50 py-4">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-center gap-3">
          <span className="text-sm text-stone-600">{t('footer.alsoAvailable')}</span>
          <a
            href="https://www.trendyol.com"
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={trackTrendyolConversion}
            className="inline-flex items-center gap-2 bg-orange-600 text-white px-4 py-1.5 rounded-full text-xs font-medium hover:bg-orange-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
            {t('footer.shopTrendyol')}
            <i className="ri-external-link-line w-3 h-3 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
      <footer className="bg-gradient-to-br from-red-900 to-orange-900 text-white">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/1681d69a5b156bf16fd7f9a96245b161/37d55afd9439dc8437e7d0e2d9fc90c4.png"
                alt="MYSA Logo"
                className="h-16 w-auto mb-4"
              />
              <p className="text-sm text-white/80 leading-relaxed">
                {t('footer.description')}
              </p>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">{t('footer.quickLinks')}</h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => scrollToSection('home')}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {t('nav.home')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('products')}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {t('nav.products')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('features')}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {t('nav.features')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('pricing')}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {t('nav.pricing')}
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">{t('footer.contact')}</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-mail-line text-lg mt-0.5"></i>
                  <span className="text-sm text-white/80">mysacoze@gmail.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-phone-line text-lg mt-0.5"></i>
                  <span className="text-sm text-white/80">+90(501) 210 6588</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-lg mt-0.5"></i>
                  <span className="text-sm text-white/80">Antalya, Türkiye</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">{t('footer.followUs')}</h4>
              <div className="flex gap-4">
                <a
                  href="https://www.instagram.com/mysacoze?igsh=YTFiYmN0cjRmdXM="
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
              </div>
              <p className="text-sm text-white/80 mt-6 leading-relaxed">
                {t('footer.community')}
              </p>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm text-white/70">
                {t('footer.rights')}
              </p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  {t('footer.privacy')}
                </a>
                <a href="#" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  {t('footer.terms')}
                </a>
                <a
                  href="https://readdy.ai/?ref=logo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
